import React from 'react'

const ProfileButton = ({Value,Action}) => {
  return (
    <button style={{
        border:"none",
        outline:"none",
        backgroundColor:"white",
        border:"1px solid grey",
        color: "black",
        padding:"8px 10px",
        borderRadius:"3px"
    }} onClick={Action}>{Value}</button>
  )
}

export default ProfileButton
